<template>
  <div v-loading="loading">
    <div class="adm-card">
      <div class="adm-card-head">
        <div class="adm-card-title">
          <span class="adm-card-title-bar" />本次登录
        </div>
        <el-button size="small" icon="el-icon-refresh" :loading="loading" @click="load">
          刷新
        </el-button>
      </div>
      <div class="adm-card-body">
        <div class="adm-desc">
          <div class="adm-desc-item">
            <span class="adm-desc-label">管理员</span>
            <span class="adm-desc-value">
              {{ admin.currentNickname || admin.currentUsername || '-' }}
            </span>
          </div>
          <div class="adm-desc-item">
            <span class="adm-desc-label">角色</span>
            <span class="adm-desc-value">{{ admin.currentRole || '-' }}</span>
          </div>
          <div class="adm-desc-item">
            <span class="adm-desc-label">登录时间</span>
            <span class="adm-desc-value">{{ formatTime(admin.currentLastLoginAt) }}</span>
          </div>
          <div class="adm-desc-item">
            <span class="adm-desc-label">登录 IP</span>
            <span class="adm-desc-value">{{ admin.currentLastLoginIp || '-' }}</span>
          </div>
        </div>
      </div>
    </div>

    <div v-for="group in groups" :key="group.title" class="adm-card">
      <div class="adm-card-head">
        <div class="adm-card-title">
          <span class="adm-card-title-bar" />{{ group.title }}
        </div>
      </div>
      <div class="adm-card-body">
        <div class="adm-stat-grid">
          <div v-for="item in group.items" :key="item.label" class="adm-stat">
            <div class="adm-stat-label">
              <span class="adm-stat-icon" :class="item.iconTone"><i :class="item.icon" /></span>
              {{ item.label }}
            </div>
            <div class="adm-stat-value adm-num" :class="item.tone">{{ fmt(item.value) }}</div>
            <div v-if="item.hint" class="adm-stat-hint">{{ item.hint }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="adm-card">
      <div class="adm-card-head">
        <div class="adm-card-title">
          <span class="adm-card-title-bar" />最近动态
          <span class="adm-card-title-extra">最近 10 条管理端操作</span>
        </div>
      </div>
      <div class="adm-card-body is-flush">
        <el-table :data="recentLogs" border>
          <el-table-column label="时间" width="170">
            <template slot-scope="{ row }">{{ formatTime(row.createdAt) }}</template>
          </el-table-column>
          <el-table-column label="操作人" width="150">
            <template slot-scope="{ row }">{{ row.adminName || '-' }}</template>
          </el-table-column>
          <el-table-column label="动作" width="120">
            <template slot-scope="{ row }">
              <el-tag size="mini" :type="actionTagType(row.action)">
                {{ row.actionDesc || row.action }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="detail" label="详情" min-width="240" show-overflow-tooltip />
        </el-table>
        <div v-if="!loading && !recentLogs.length" class="adm-empty">
          <i class="el-icon-folder-opened" />暂无操作记录
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchOverview, isOk, isNotLogin } from '@/api/admin'

export default {
  name: 'OverviewPanel',
  data() {
    return {
      loading: false,
      user: {},
      content: {},
      audit: {},
      inviteCode: {},
      admin: {},
      recentLogs: []
    }
  },
  computed: {
    groups() {
      return [
        {
          title: '用户',
          items: [
            { label: '用户总数', value: this.user.total, icon: 'el-icon-user', iconTone: '' },
            {
              label: '状态正常',
              value: this.user.normal,
              icon: 'el-icon-circle-check',
              iconTone: 'is-success'
            },
            {
              label: '已禁用',
              value: this.user.disabled,
              icon: 'el-icon-warning-outline',
              iconTone: 'is-warn',
              tone: this.num(this.user.disabled) > 0 ? 'is-warn' : ''
            },
            { label: '今日新增', value: this.user.todayNew, icon: 'el-icon-time', iconTone: '' },
            { label: '近 7 天新增', value: this.user.weekNew, icon: 'el-icon-date', iconTone: '' }
          ]
        },
        {
          title: '内容',
          items: [
            {
              label: '随想',
              value: this.content.thoughts,
              icon: 'el-icon-edit-outline',
              iconTone: 'is-neutral'
            },
            {
              label: '时间块',
              value: this.content.timeBlocks,
              icon: 'el-icon-time',
              iconTone: 'is-neutral'
            },
            {
              label: '任务',
              value: this.content.tasks,
              icon: 'el-icon-tickets',
              iconTone: 'is-neutral'
            },
            {
              label: '工作区',
              value: this.content.workspaces,
              icon: 'el-icon-folder',
              iconTone: 'is-neutral'
            },
            {
              label: '项目',
              value: this.content.projects,
              icon: 'el-icon-files',
              iconTone: 'is-neutral'
            }
          ]
        },
        {
          title: '内容审核',
          items: [
            { label: '审核流水', value: this.audit.recordTotal, icon: 'el-icon-s-check', iconTone: '' },
            {
              label: '累计下架',
              value: this.audit.hideCount,
              icon: 'el-icon-circle-close',
              iconTone: 'is-danger'
            },
            {
              label: '累计恢复',
              value: this.audit.restoreCount,
              icon: 'el-icon-refresh-left',
              iconTone: 'is-success'
            }
          ]
        },
        {
          title: '邀请码',
          items: [
            { label: '总数', value: this.inviteCode.total, icon: 'el-icon-tickets', iconTone: '' },
            {
              label: '未使用',
              value: this.inviteCode.unused,
              icon: 'el-icon-circle-check',
              iconTone: 'is-success'
            },
            {
              label: '已用完',
              value: this.inviteCode.used,
              icon: 'el-icon-check',
              iconTone: 'is-neutral'
            },
            {
              label: '已禁用',
              value: this.inviteCode.disabled,
              icon: 'el-icon-remove',
              iconTone: 'is-danger'
            },
            {
              label: '已过期',
              value: this.inviteCode.expired,
              icon: 'el-icon-time',
              iconTone: 'is-warn'
            }
          ]
        },
        {
          title: '管理端',
          items: [
            {
              label: '管理员账号',
              value: this.admin.total,
              icon: 'el-icon-s-custom',
              iconTone: 'is-neutral'
            },
            {
              label: '操作日志',
              value: this.admin.operationLogTotal,
              icon: 'el-icon-files',
              iconTone: 'is-neutral'
            }
          ]
        }
      ]
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      if (this.loading) return
      this.loading = true
      fetchOverview()
        .then(res => {
          // 会话过期不弹错，交给 AdminPage 的登录门处理
          if (isNotLogin(res)) return
          if (!isOk(res)) {
            throw new Error(res && res.message ? res.message : '获取概览失败')
          }
          const d = res.data || {}
          this.user = d.user || {}
          this.content = d.content || {}
          this.audit = d.audit || {}
          this.inviteCode = d.inviteCode || {}
          this.admin = d.admin || {}
          this.recentLogs = d.recentLogs || []
        })
        .catch(err => {
          this.$message.error(err.message || '获取概览失败')
        })
        .finally(() => {
          this.loading = false
        })
    },
    /** 后端把 Long 序列化成字符串，展示前统一转数字 */
    num(v) {
      const n = Number(v)
      return Number.isFinite(n) ? n : 0
    },
    fmt(v) {
      return this.num(v).toLocaleString('zh-CN')
    },
    actionTagType(action) {
      if (!action) return 'info'
      if (action.indexOf('INVITE') === 0) return 'success'
      if (action.indexOf('CONTENT') === 0) return 'warning'
      if (action.indexOf('USER') === 0) return 'danger'
      return 'info'
    },
    formatTime(value) {
      if (!value) return '-'
      return String(value).replace('T', ' ').slice(0, 19)
    }
  }
}
</script>

<style scoped>
/* 卡片 / 统计卡 / 描述列表的样式统一来自 @/styles/admin.css */
.adm-stat-icon i {
  font-size: 15px;
}

/* 窄屏时描述列表退化成单列 */
@media (max-width: 720px) {
  .adm-desc {
    grid-template-columns: minmax(0, 1fr);
  }

  .adm-desc-item {
    border-right: none;
  }
}
</style>
